'use strict'

const containerBoxesSection = require('../sections/box/containerBoxesSection')
const stateBoxSection = require('../sections/stateBox/stateBoxSection')

module.exports = {
    containerBoxesSection,
    stateBoxSection
}
